import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "matching-link-icon",
  role: "img",
  viewBox: "0 0 14 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0)\"><line x1=\"7.5\" y1=\"4.37114e-8\" x2=\"7.5\" y2=\"24\" stroke=\"#919AA8\" stroke-width=\"2\"></line><circle cx=\"7\" cy=\"12.5\" r=\"5.5\" fill=\"#F6F7F8\" stroke=\"#919AA8\" stroke-width=\"2\"></circle></g><defs><clipPath id=\"clip0\"><rect width=\"13\" height=\"24\" transform=\"translate(0.5)\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render: render }